import { call, put } from 'redux-saga/effects';
import { API_BASE_URL, getRequest, putRequest } from "../../../api";
import Swal from 'sweetalert2';
import {
    FETCH_ONBOARDING_SPONSOR_CONFIG_SUCCESS,
    FETCH_ONBOARDING_SPONSOR_CONFIG_FAILURE,
    UPDATE_ONBOARDING_SPONSOR_CONFIG_SUCCESS,
    UPDATE_ONBOARDING_SPONSOR_CONFIG_FAILURE,
} from '../actions/onboardingSponsorConfigActions';

const getUid = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

export function* fetchOnboardingSponsorConfigSaga() {
    const url = `${API_BASE_URL}/api/onboarding-sponsor-config`;
    const uid = getUid();
    const token = getToken();

    try {
        const response = yield call(getRequest, { url, uid, token });
        yield put({ type: FETCH_ONBOARDING_SPONSOR_CONFIG_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({
            type: FETCH_ONBOARDING_SPONSOR_CONFIG_FAILURE,
            payload: error.response?.data?.message || error.message
        });
    }
}

export function* updateOnboardingSponsorConfigSaga(action) {
    const url = `${API_BASE_URL}/api/onboarding-sponsor-config`;
    const uid = getUid();
    const token = getToken();

    try {
        const response = yield call(putRequest, { url, data: action.payload, uid, token });
        yield put({ type: UPDATE_ONBOARDING_SPONSOR_CONFIG_SUCCESS, payload: response.data });
        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: 'Configuration enregistrée',
            text: 'Les paramètres de parrainage ont été mis à jour.',
            timer: 2000,
            showConfirmButton: false,
        });
    } catch (error) {
        yield put({
            type: UPDATE_ONBOARDING_SPONSOR_CONFIG_FAILURE,
            payload: error.response?.data?.message || error.message
        });
        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: 'Erreur',
            text: error.response?.data?.message || 'Une erreur est survenue lors de l\'enregistrement.',
        });
    }
}
